export default {"src":"/_next/static/media/ga-15-plus.f714c696.svg","height":48,"width":372,"blurWidth":0,"blurHeight":0};